import styled from 'styled-components';

const Head = styled.div`
  display: flex;
  flex-direction: row;
  grid-gap: 30px;
  justify-content: flex-end;
  align-items: center;
  margin: 20px 0;
`;

const PaginationWrapper = styled.div`
  margin: 30px 0;
  display: flex;
  justify-content: flex-end;
`;

export { Head, PaginationWrapper };
